var render = function render(_c, _vm) {
  return _c("notifications", {
    attrs: { group: "main", position: "top right" },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function (props) {
          return [
            _c(
              "div",
              { staticClass: "notification-content" },
              [
                _c("svgicon", {
                  attrs: {
                    icon: "alert-circle",
                    height: "24",
                    width: "24",
                    color: "#EC513A",
                  },
                }),
                _c(
                  "p",
                  { staticClass: "notification-text redVidid mg mg--l-2" },
                  [_vm._v(_vm._s(props.item.data.text))]
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }